export enum AttachmentFilterType {
  All = 'All',
  EDocument = 'EDocument',
  Scout = 'Scout',
  Upload = 'Upload',
  Blocked = 'Blocked',
  Approved = 'Approved',
}
